import {Directive, ViewChild, Input, TemplateRef} from '@angular/core';

/** Used to flag tab labels for use with the portal directive */
@Directive({
  selector: '[uex-tab-label]'
})
export class TabLabelDirective {
  @Input('class') css_name: any;

  constructor(
    private _content: TemplateRef<any>
  ) { }
}
